import { ConnectedRouter } from 'connected-react-router';
import React from 'react';
import { Provider } from 'react-redux';
import { Switch } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import PrivateRoute from './Routes/PrivateRoute';
import PublicRoute from './Routes/PublicRoute';
import routesData from './Routes/routesData';
import history from './Store/history';
import { persistor, store } from './Store/store';

function App(params) {
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <PersistGate persistor={persistor}>
          <Switch>
            {routesData.map((route, index) => {
              if (route.auth) {
                return <PrivateRoute {...route} key={index} />;
              } else {
                return <PublicRoute {...route} key={index} />;
              }
            })}
          </Switch>
        </PersistGate>
      </ConnectedRouter>
    </Provider>
  );
}
export default App;
